import React  from 'react';
import Modal from 'react-bootstrap/Modal';
import Moment from 'react-moment';

function AppliedCompanies({ handleClick, validatepopupshow,  appliedList} ) {
  console.log("appliedList",appliedList );
  return (

  <Modal show={validatepopupshow}         
      backdrop="static"
      keyboard={false}
      size="lg"
      onHide={() => { handleClick() }}

      >
    <Modal.Header closeButton  >
         <Modal.Title style={{padding:"0px 20px",fontSize:"20px"}} >Applied Companies</Modal.Title>
    </Modal.Header>
    <Modal.Body >
      <div style={{padding:"10px 20px"}}>
      <p>You have already applied to the following companies  within the last 6 months.<br/>
Please remove these companies from your list and consider applying to other companies on our platform.</p>
      <div className="applied-list-table">
        <table className="table table-hover   table-striped" >
        <thead>
            <tr style={{backgroundColor:"#a7a7c1",color:'#fff'}} >
                <th scope="col" className="text-nowrap">Company Name</th>
                <th scope="col" className="text-nowrap" >Job Description</th>
                <th scope="col" className="text-nowrap">Applied Date</th>
            </tr>
        </thead>
        <tbody>
            {
              appliedList.map((item, index)=>
                <tr key={index}>
                  <td >{item.company}</td>
                  <td >{item.description}</td>
                  <td ><Moment date={item.applied_date}format="DD/MM/YYYY"  /></td>
                </tr>
              
              )
            }
        </tbody>
        </table>
      </div>
      <div className='text-end'>
        <button  className='btn btn-primary' id='volsavebtn' 
            style={{ backgroundColor: "white", color: "#1959ba" }}  
            
            onClick={() => { handleClick() }}
            >
              Close</button>
      </div>
     
      </div>
    </Modal.Body>
  </Modal>
  )
}

export default AppliedCompanies